import { AuthenticationToken } from '@mindfulchefuk/api-client'
import { setToken } from '@mindfulchefuk/helpers/tokens/setToken'

export const verifyOtp = async (
  email: string,
  password: string,
  code: string
): Promise<string> => {
  const authToken = new AuthenticationToken({
    email: email.toLowerCase(),
    password,
    otp_code: code,
  })

  const result = await authToken.save()

  if (result) {
    setToken(authToken.access_token)
  }

  return authToken.customer_id
}
